import React from "react"
import { Link } from "react-router"

export default  function BusinessLink({ id, name, businessId }) {
  return <Link to={`/businesses/${id}/detail`} title='Show details'>
    { name } - { businessId }
  </Link>
}



// WEBPACK FOOTER //
// ./src/components/fragments/BusinessLink.js